module.exports = __webpack_public_path__ + "static/media/machine-handler-hover.9b8f6237.png";